import Container from '@atoms/Container';
import QuicklinksAlt from '@blocks/QuicklinksAlt';
import apCaseOnlyTitleTags from '@utils/apCaseOnlyTitleTags';
import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context';
import { colors } from '../primitives/colors';
import RichText from '../primitives/richtext/index.tsx';
import { StaticImage } from 'gatsby-plugin-image';

const ServicesDetail = ({ data }) => {
    const {
        headline,
        copy: originalCopy,
        quicklinks,
        override_with_unique_content: override,
    } = data;
    const { isMicrosite, uniqueContent, franchise } = useMicrosite();

    const hasQuickLinks = quicklinks?.links?.length > 0;

    const copy = (
        (override && isMicrosite) ? uniqueContent[override]?.rawContent ?? originalCopy : originalCopy
    );

    const overrideUsed = isMicrosite && copy === uniqueContent[override]?.rawContent;

    return (
        <div css={styles.background}>
            <Container css={styles.container}>
                <div css={styles.contentWrapLeft}>
                    {/* <Breadcrumbs css={styles.breadcrumbs} /> */}
                    <h2
                        css={styles.headline}
                        dangerouslySetInnerHTML={{ __html: apCaseOnlyTitleTags(headline) }}
                    />
                    <RichText maxLength={overrideUsed ? 12 : undefined} css={styles.copy}>
                        {copy}
                    </RichText>
                </div>
                <div css={styles.contentWrapRight}>
                    {hasQuickLinks && <QuicklinksAlt data={quicklinks} />}
                    {isMicrosite && override == 'index' && franchise.franchiseNumber == 11330 && <StaticImage
                                    sizes="(max-width: 400px) 800px, (max-width: 900px) 1200px, (max-width: 1200px) 1600px"
                                    css={{
                                        maxHeight: 400,
                                        maxWidth: 400,
                                        borderRadius: '30px',
                                        margin: 'auto'
                                    }}
                                    alt="Certificates"
                                    formats={['AUTO', 'WEBP']}
                                    src="https://franchiseadmin.servpro.com/FranchiseContent/NewsPhotos/11330-6fad8462-97e7-4c41-9f6d-5f4e7815e5f7.png"
                                />}
                </div>
            </Container>
        </div>
    );
};

const styles = {
    background: {
        position: 'relative',
        zIndex: 10,
        paddingTop: '2rem',
        paddingBottom: '2rem',
        backgroundColor: colors.grey100,
        '@media (min-width: 768px)': {
            paddingTop: '4rem',
            paddingBottom: '4rem',
        },
    },
    container: {
        '@media (min-width: 1024px)': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
    },
    contentWrapLeft: {
        '@media (min-width: 1024px)': { width: '50%' },
    },
    contentWrapRight: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        '@media (min-width: 1024px)': { width: '50%' },
    },
    headline: {
        fontSize: '2.25rem',
        lineHeight: 1,
        marginBottom: '1.25rem',
        marginRight: 'auto',
        marginLeft: 'auto',
        '@media (min-width: 1024px)': {
            fontSize: '54px',
        },
    },
    copy: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        whiteSpace: 'pre-line',
        marginRight: 'auto',
        marginLeft: 'auto',
        '@media (min-width: 1024px)': {
            maxWidth: '48rem',
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    breadcrumbs: { marginBottom: '0.75rem' },
};

export const query = graphql`
    fragment ServicesDetailData on CmsPageBuilderBlocks {
        services_detail {
            headline
            copy
            override_with_unique_content
            quicklinks {
                heading
                links {
                    href
                    title
                }
            }
        }
    }
`;

export default ServicesDetail;
